var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 7.83002L9.91998 0.339996C9.68998 0.119996 9.38997 0 9.08997 0C8.78997 0 8.49001 0.109996 8.26001 0.339996L0.390015 7.83002C0.140015 8.07002 0 8.4 0 8.75V16.94C0 17.63 0.539971 18.2 1.21997 18.2H5.52997C6.20997 18.2 6.75 17.63 6.75 16.94V13.51C6.75 12.17 7.79997 11.09 9.08997 11.09C10.38 11.09 11.44 12.17 11.44 13.51V16.94C11.44 17.63 11.98 18.2 12.66 18.2H16.96C17.64 18.2 18.19 17.63 18.19 16.94V8.75C18.19 8.4 18.04 8.06002 17.8 7.83002ZM16.87 16.85H12.77V13.52C12.77 11.43 11.12 9.74002 9.09998 9.74002C7.07998 9.74002 5.42999 11.44 5.42999 13.52V16.85H1.33002V8.80002L9.09998 1.41L16.88 8.80002V16.85H16.87Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.bcb03a6fb5de67409740d9b87807b596.svg";
export { ForwardRef as ReactComponent };